// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33Ng7","largestCol":"styles_largestCol__1xWne","smallestCol":"styles_smallestCol__vj-Zz"};